define('PriceMatch.Button.View',
  [
    'AjaxRequestsKiller',
    'Backbone',
    'Profile.Model',
    'PriceMatch.Form.View',
    'price_match_button.tpl',
    'jQuery',
    'underscore'
  ],
  function (
    AjaxRequestsKiller,
    Backbone,
    ProfileModel,
    PriceMatchFormView,
    price_match_button_tpl,
    jQuery,
    _
  ) {
    'use strict';

    return Backbone.View.extend({
      template: price_match_button_tpl,

      initialize: function (options) {
        this.application = options.application;
        this.item = options.item;
        this.itemId = this.item.internalid;
        this.isLoggedIn = ProfileModel.getInstance().isLoggedIn();
      },

      events: {
        'click [data-action="showPriceMatchModal"]': 'showPriceMatchModal'
      },

      showPriceMatchModal: function (e) {
        e.preventDefault();
        var formView = new PriceMatchFormView({
          application: this.application,
          item: this.item,
          user: ProfileModel.getInstance()
        });
        this.application.getLayout().showInModal(formView);
      },

      getContext: function () {
        return {
          isLoggedIn: this.isLoggedIn
        };
      }
    });
  });
